import Vue from 'vue'
import Vuex from 'vuex'
import request from "@/utils/request";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
